import React from 'react';
import { useTranslation } from 'react-i18next';
import AppIcon from '../../../../components/AppIcon';

const PrivacyIndicator: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="border border-border rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <AppIcon name="Lock" size={20} className="text-primary me-3 mt-0.5 shrink-0" />
        <div>
          <p className="text-sm font-semibold text-foreground mb-1">
            {t('performance.espn.privacyTitle')}
          </p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            {t('performance.espn.privacyDescription')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyIndicator;
